<template>
    <table class="table table-sm mb-0">
        <tr v-if="entry.editable">
            <td style="width: 20%" class="pt-2">
                <span class="client-name">{{ clientName }}</span>
            </td>
            <td style="width: 20%">
                <type-form :entry="entry"/>
            </td>
            <td style="width: 8%">
                <fiscal-year-form :entry="entry"/>
            </td>
            <td style="width: 8%">
                <duration-form
                    :entry="entry"
                    @updated="$emit('duration-has-changed')"
                />
            </td>
            <td>
                <comments-form :entry="entry"/>
            </td>
            <td style="width: 8%" class="text-right">
                <b-link
                    title="Supprimer"
                    class="text-danger"
                    @click="confirmDelete"
                >
                    <i class="fas fa-trash-alt fa-fw fa-lg"></i>
                </b-link>
            </td>
        </tr>
        <tr v-else>
            <td style="width: 20%" class="pt-2">
                <span style="font-size: 12px">Non affecté</span>
            </td>
            <td style="width: 20%">
                <span style="font-size: 12px" class="pl-2">{{ entry.description }}</span>
            </td>
            <td style="width: 8%">
            </td>
            <td style="width: 8%" class="text-center">
                <span style="font-size: 12px">{{ entry.activity_duration.toFixed(2) }}</span>
            </td>
            <td>
                <span style="font-size: 12px" class="pl-2">{{ entry.comments }}</span>
            </td>
            <td style="width: 8%" class="text-right">

            </td>
        </tr>
    </table>
</template>

<script>
import DurationForm from './DurationForm.vue'
import CommentsForm from './CommentsForm.vue'
import TypeForm from './TypeForm.vue'
import FiscalYearForm from './FiscalYearForm.vue'

export default {
    name: 'NotAffectedEntryEdit',

    components: {
        TypeForm,
        CommentsForm,
        DurationForm,
        FiscalYearForm,
    },

    props: {
        entry: {
            type: Object,
            required: true,
        },
    },

    computed: {
        clientName() {
            return this.entry.client === null
                ? 'Non affecté'
                : this.entry.client.name
        },

        dateDisplay() {
            return (
                this.entry.activity_date.substring(8, 10) +
                '/' +
                this.entry.activity_date.substring(5, 7) +
                '/' +
                this.entry.activity_date.substring(0, 4)
            )
        },
        disabled() {
            return false
        }
    },

    methods: {
        confirmDelete() {
            this.$bvModal
                .msgBoxConfirm(
                    'Etes-vous sûr·e de vouloir supprimer cette ligne ?',
                    {
                        title: "Suppression d'une ligne",
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'OUI',
                        cancelTitle: 'NON',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then((value) => {
                    if (value) {
                        this.deleteEntry()
                    }
                })
                .catch((err) => {
                    // An error occurred
                })
        },

        async deleteEntry() {
            try {
                await axios.delete(`/time-sheets/${this.entry.id}`)
                this.$emit('entry-is-deleted')
                // this.$root.$refs.timeSheetsInput.getData()
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>

<style scoped>
.client-name {
    font-size: 12px;
}
</style>
